import { ctaDesc, ctaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import ApostilleProductPage from "@/components/ApostilleProductPage";
import { apostilleProductGraph, defaultApostilleProductFaqs } from "@/lib/apostille-product-schema";
import { BRAND_URL } from "@/lib/brand";

export const Route = createFileRoute("/en/apostille/products/$slug")({
  loader: async ({ params }) => {
    const { getApostilleProduct } = await import("@/data/apostille-products");
    const p = getApostilleProduct(params.slug);
    if (!p) throw notFound();
    return { product: p };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("Not found", "/en/apostille/products/$slug", "en")}, { name: "robots", content: "noindex" }] };
    const p = loaderData.product;
    const path = `/en/apostille/products/${params.slug}`;
    const url = `${BRAND_URL}${path}`;
    const title = `Apostille ${p.nameEn} — Thailand MFA Legalisation | ${p.turnaround}`;
    const desc = p.shortDescEn + " · Translation + Notary + MFA + destination Apostille under one roof. 125+ Hague members including China.";
    const faqs = defaultApostilleProductFaqs(p, "en");
    return {
      meta: [
        { title: ctaTitle(title, "/en/apostille/products/$slug", "en") }, { name: "description", content: ctaDesc(desc, "/en/apostille/products/$slug", "en")},
        { property: "og:title", content: ctaTitle(title, "/en/apostille/products/$slug", "en")},
        { property: "og:description", content: ctaDesc(desc, "/en/apostille/products/$slug", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "product" },
        { property: "og:locale", content: "en_US" },
        { property: "product:price:amount", content: String(p.priceMid) },
        { property: "product:price:currency", content: "THB" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "en", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: `${BRAND_URL}/apostille/products/${params.slug}` },
        { rel: "alternate", hrefLang: "x-default", href: `${BRAND_URL}/apostille/products/${params.slug}` },
      ],
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(apostilleProductGraph({ product: p, locale: "en", path, faqs })),
      }],
    };
  },
  notFoundComponent: () => <div className="p-16 text-center">Service not found</div>,
  component: () => {
    const { product } = Route.useLoaderData();
    return <ApostilleProductPage product={product} locale="en" faqs={defaultApostilleProductFaqs(product, "en")} />;
  },
});
